import { defineAsyncComponent } from "vue";
import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import { useUserStore } from "@/stores/user";

export const financingManagementRouter: RouteRecordRaw[] = [
    {
        path: "/financing",
        name: "FinancingManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/financing/customer",
        meta: {
            title: "融资管理"
        },
        children: [
            {
                path: "/financing/customer",
                name: "CustomerFinancing",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/customerFinancing/index.vue");
                    }
                }),
                meta: {
                    title: "融资列表",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/financing/customer/:id",
                name: "CustomerFinancingDetail",
                component: () => import("@/views/pages/financingManagement/customerFinancing/detail.vue"),
                meta: {
                    hidden: true,
                    activeMenu: "CustomerFinancing",
                    title: "融资详情",
                    // keepAlive: false,
                    isNotShowHeader: true
                }
            },
            // {
            //     path: "/financing/register",
            //     name: "FinancingRegister",
            //     component: () => import("@/views/pages/financingManagement/customerFinancing/index.vue"),
            //     meta: {
            //         title: "融资登记",
            //         isNotShowHeader: true
            //     }
            // },
            {
                path: "/financing/log",
                name: "LouManagement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/louManagement/index.vue");
                    }
                }),
                meta: {
                    title: "借据列表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/financing/refund",
                name: "RefundManagement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/refundManagement/index.vue");
                    }
                }),
                meta: {
                    title: "还款放货",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/financing/refundDetail",
                name: "RefundManagementDetail",
                component: () => import("@/views/pages/financingManagement/refundManagement/detail.vue"),
                meta: {
                    title: "还款详情",
                    isNotShowHeader: true,
                    hidden: true,
                    activeMenu: "RefundManagement"
                }
            },
            {
                path: "/financing/refundAdd",
                name: "RefundManagementAdd",
                component: () => import("@/views/pages/financingManagement/refundManagement/form.vue"),
                meta: {
                    title: "还款放货申请",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "RefundManagement"
                }
            },
            {
                path: "/financing/refundEdit",
                name: "RefundManagementEdit",
                component: () => import("@/views/pages/financingManagement/refundManagement/form.vue"),
                meta: {
                    title: "修改还款",
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "RefundManagement"
                }
            }
        ]
    }
];

export default financingManagementRouter;
